<template>
    <base-modal :value="value" @input="canceled"
        modal-classes="modal-success"
        modal-content-classes="bg-gradient-success"
    >
        <div class="py-3 text-center">
            <i class="tim-icons icon-check-single icon-3x mb-4"></i>
            <slot></slot>
        </div>

        <template slot="footer">
            <div class="text-center">
                <base-button type="white" @click="close">{{ $t('common.close') }}</base-button>
            </div>
        </template>
    </base-modal>
</template>

<script>
    export default {
        
        props: {
            value: {
                type: Object,
                required: true
            },
        },

        methods: {

            close() {
                this.$emit('input', {
                    id: this.value.id,
                    show: false,
                })
            }
        }
    }
</script>